import { createAction } from 'redux-actions'

export const SET_ADBLOCKER_STATUS = 'AdBlocker: Sets status to true if adblocker is active'

const setAdBlockerStatus = createAction(SET_ADBLOCKER_STATUS)

const detectAdBlocker = (status) => (dispatch) => {
  dispatch(setAdBlockerStatus(status))
}

export const actionCreators = {
  detectAdBlocker,
}
